(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4338],{

/***/ 34338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ PopularDirections; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33562);
/* harmony import */ var _LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _SearchBox_SearchBox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19);
/* harmony import */ var _react_hook_window_size__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61715);
/* harmony import */ var _mui_icons_material_AirplanemodeActive__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86235);
/* harmony import */ var _ImageWithFallback_ImageWithFallback__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74284);
/* harmony import */ var _RecommendationsList_RecommendationsList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39972);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70131);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14416);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _assets_arrow_left_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40160);
/* harmony import */ var _utils_checkUserCountry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65024);
/* harmony import */ var _OffersViews_OffersViews__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87302);

















var CallToSignUp = next_dynamic__WEBPACK_IMPORTED_MODULE_9___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8307), __webpack_require__.e(8746)]).then(__webpack_require__.bind(__webpack_require__, 68307));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68307)
            ];
        }
    }
});
var RegionalDealsTable = next_dynamic__WEBPACK_IMPORTED_MODULE_9___default()(function() {
    return __webpack_require__.e(/* import() */ 8335).then(__webpack_require__.bind(__webpack_require__, 58335));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58335)
            ];
        }
    },
    ssr: false
});
var PopularDirections = function(param) {
    var cabinClass = param.cabinClass, popularDirections = param.popularDirections, popularRoutes = param.popularRoutes, routesPage = param.routesPage, directionsPage = param.directionsPage, totalRoutesPages = param.totalRoutesPages, totalDirectionsPages = param.totalDirectionsPages, recommendation = param.recommendation, topImage = param.topImage, authCompleted = param.authCompleted, seoHTML = param.seoHTML;
    var getDirectionItem = function getDirectionItem(direction) {
        var ref;
        function generateTitle() {
            return "Flights\n      ".concat(direction.cityFromName ? " from " + direction.cityFromName : "", "\n     to ").concat(direction.cityToName);
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: "/flights" + direction.url,
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().card), "relative"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().recomendationContainer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().icon), "bg-review-iconAirlines"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_AirplanemodeActive__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            fontSize: "small",
                            className: "m-auto text-white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "h-full flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().imageContainer),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ImageWithFallback_ImageWithFallback__WEBPACK_IMPORTED_MODULE_5__/* .ImageWithFallback */ .J, {
                                    src: "https://media.first-class.com/" + ((ref = direction.image) === null || ref === void 0 ? void 0 : ref.replace("/", "")),
                                    objectFit: "cover",
                                    layout: "fill",
                                    alt: direction.cityFromName + " - " + direction.cityToName + " image"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text), "relative flex flex-col justify-center items-start"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().type), "font-libre "),
                                        children: generateCabinClass().name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().title), "font-fragment"),
                                        children: generateTitle()
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }, direction.url);
    };
    var getRoutesPaginationUrl = function getRoutesPaginationUrl() {
        var rotePrevious = +routesPage - 1;
        return +directionsPage === 0 && rotePrevious === 0 ? "/flights/".concat(cabinClass) : "/flights/".concat(cabinClass, "?directionsPage=").concat(+directionsPage, "&routesPage=").concat(rotePrevious);
    };
    var getDirectionsPaginationUrl = function getDirectionsPaginationUrl() {
        var directionPrevious = +directionsPage - 1;
        return +routesPage === 0 && directionPrevious === 0 ? "/flights/".concat(cabinClass) : "/flights/".concat(cabinClass, "?directionsPage=").concat(directionPrevious, "&routesPage=").concat(+routesPage);
    };
    var ref, ref1, ref2, ref3;
    var userStore = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(function(state) {
        return state.user.value;
    });
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), searchBoxState = ref4[0], setSearchBoxState = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), dealsAvailable = ref5[0], setDealsAvailable = ref5[1];
    var defaultOrigin = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return {
            origin: "All origins",
            country: userStore === null || userStore === void 0 ? void 0 : userStore.country
        };
    }, [
        userStore === null || userStore === void 0 ? void 0 : userStore.country
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (cabinClass) {
            var getCabinClassCode = function(textId) {
                switch(textId){
                    case "business-class":
                        return "BIZ";
                    case "premium-economy-class":
                        return "FLX";
                    case "first-class":
                        return "FST";
                    default:
                        return "ECO";
                }
            };
            setSearchBoxState({
                from: null,
                exactFrom: false,
                to: null,
                exactTo: false,
                tripState: "round_trip",
                cabinClass: getCabinClassCode(cabinClass),
                dateRange: {
                    departure: null,
                    return: null
                },
                departure: null,
                airlineType: "all",
                passengers: {
                    adults: 1
                },
                multi_city: [
                    {
                        from: null,
                        to: null,
                        departure: null,
                        airlineType: "all"
                    }, 
                ]
            });
        }
    }, [
        cabinClass
    ]);
    var generateCabinClass = function() {
        switch(cabinClass){
            case "premium-economy-class":
                return {
                    name: "Premium Economy Class",
                    code: "FLX"
                };
            case "business-class":
                return {
                    name: "Business Class",
                    code: "BIZ"
                };
            case "first-class":
                return {
                    name: "First Class",
                    code: "FST"
                };
            default:
                return {
                    name: "Economy Class",
                    code: "ECO"
                };
        }
    };
    var width = (0,_react_hook_window_size__WEBPACK_IMPORTED_MODULE_15__/* .useWindowWidth */ .Lm)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index, follow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            "Cheap ",
                            generateCabinClass().name,
                            " Flights, Tickets & Deals"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: cabinClass ? "".concat("https://www.first-class.com", "/flights/").concat(cabinClass) : "".concat("https://www.first-class.com", "/flights")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Save big on luxury travel! Find unbeatable deals on cheap ".concat(generateCabinClass().name.toLowerCase(), " flights and tickets. Elevate your journey with First-Class.com today!")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "first-class.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Cheap ".concat(generateCabinClass().name, " Flights, Tickets & Deals")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "Save big on luxury travel! Find unbeatable deals on cheap ".concat(generateCabinClass().name.toLowerCase(), " flights and tickets. Elevate your journey with First-Class.com today!")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: topImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Cheap ".concat(generateCabinClass().name, " Flights, Tickets & Deals")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: topImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Save big on luxury travel! Find unbeatable deals on cheap ".concat(generateCabinClass().name.toLowerCase(), " flights and tickets. Elevate your journey with First-Class.com today!")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().landing)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().topSection)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                className: "vjs-tech",
                                src: topImage,
                                alt: "Top image",
                                layout: "fill",
                                objectFit: "cover"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().topSectionText), "font-fragment", (0,_utils_checkUserCountry__WEBPACK_IMPORTED_MODULE_11__/* .checkUserCountry */ .u)(userStore === null || userStore === void 0 ? void 0 : userStore.country) && dealsAvailable ? (_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().topDeals) : ""),
                                children: [
                                    generateCabinClass().name,
                                    " Flights"
                                ]
                            }),
                            userStore && userStore.country && (0,_utils_checkUserCountry__WEBPACK_IMPORTED_MODULE_11__/* .checkUserCountry */ .u)(userStore.country) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dealsTable), "container"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RegionalDealsTable, {
                                    country: userStore.country,
                                    currency: userStore.currency,
                                    cabinClass: generateCabinClass().code,
                                    cabinClassTitle: generateCabinClass().name,
                                    intervalSeconds: 7,
                                    setDealsAvailable: setDealsAvailable
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().content),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().topSectionSearch), "container mx-auto px-4", dealsAvailable ? (_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().topDeals) : ""),
                                    children: width >= 1024 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchBox_SearchBox__WEBPACK_IMPORTED_MODULE_4__/* .SearchBox */ .R, {
                                        type: "mainSearch",
                                        activeTab: 0,
                                        flightSearchValue: searchBoxState,
                                        searchSource: "".concat(generateCabinClass().name, " Flights Page")
                                    })
                                }),
                                width < 1024 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().contentSearch), "mx-auto"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchBox_SearchBox__WEBPACK_IMPORTED_MODULE_4__/* .SearchBox */ .R, {
                                        type: "sideSearch",
                                        activeTab: 0,
                                        flightSearchValue: searchBoxState,
                                        searchSource: "".concat(generateCabinClass().name, " Flights Page")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().content), "px-4 mt-4"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OffersViews_OffersViews__WEBPACK_IMPORTED_MODULE_12__/* .OffersViews */ .Y, {
                                    defaultCabinClass: generateCabinClass().code,
                                    filtersShown: false,
                                    searchSource: "Offer on ".concat(generateCabinClass().name, " Flights Page"),
                                    customHeader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                        className: "font-libre text-xl my-5 lg:my-10",
                                        children: [
                                            "Latest ",
                                            generateCabinClass().name,
                                            " round-trip flight deals"
                                        ]
                                    }),
                                    defaultOrigin: defaultOrigin,
                                    defaultDestination: undefined,
                                    allAirlines: true
                                }),
                                !!((ref = popularDirections.content) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsText), "text-left mb-6 mt-8 lg:pl-4 px-4 lg:pr-0"),
                                    children: "Popular destinations"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsList), "lg:pl-8 px-4 lg:pr-0"),
                                    children: popularDirections.content.slice(0, 9).map(function(direction) {
                                        return getDirectionItem(direction);
                                    })
                                })
                            ]
                        })
                    }),
                    userStore && !userStore.userid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intersection_observer__WEBPACK_IMPORTED_MODULE_16__/* .InView */ .df, {
                        triggerOnce: true,
                        children: function(param) {
                            var inView = param.inView, ref = param.ref;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: ref,
                                className: "mt-6 mb-8",
                                children: inView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CallToSignUp, {
                                        country: userStore === null || userStore === void 0 ? void 0 : userStore.country,
                                        authCompleted: authCompleted,
                                        sourcePage: generateCabinClass().name + " Popular Directions"
                                    })
                                })
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsList), "lg:pl-8 px-4 lg:pr-0 mt-4"),
                                children: popularDirections.content.slice(9, popularDirections.content.length).map(function(direction) {
                                    return getDirectionItem(direction);
                                })
                            }),
                            !!((ref1 = popularDirections.content) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsListPagination),
                                children: [
                                    !!+directionsPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: getDirectionsPaginationUrl(),
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsListPaginationItem), "font-fragment"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                style: {
                                                    zIndex: 2,
                                                    buttonOffset: 15,
                                                    borderRadius: "50%",
                                                    textAlign: "center",
                                                    border: "1.5px solid #D4A976",
                                                    backgroundColor: "#202020",
                                                    color: "#D4A976",
                                                    width: "50px",
                                                    height: "50px",
                                                    lineHeight: "50px",
                                                    marginRight: "1rem",
                                                    cursor: "pointer"
                                                },
                                                type: "button",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_arrow_left_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    fontSize: "small",
                                                    style: {
                                                        marginLeft: 17
                                                    }
                                                })
                                            }),
                                            "Previous"
                                        ]
                                    }),
                                    directionsPage < totalDirectionsPages - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: "/flights/".concat(cabinClass, "?directionsPage=").concat(+directionsPage + 1, "&routesPage=").concat(+routesPage),
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsListPaginationItem), "font-fragment ml-auto"),
                                        children: [
                                            "Next",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                style: {
                                                    zIndex: 2,
                                                    buttonOffset: 15,
                                                    borderRadius: "50%",
                                                    textAlign: "center",
                                                    border: "1.5px solid #D4A976",
                                                    backgroundColor: "#202020",
                                                    color: "#D4A976",
                                                    width: "50px",
                                                    height: "50px",
                                                    lineHeight: "50px",
                                                    marginLeft: "1rem",
                                                    cursor: "pointer",
                                                    transform: "rotate(180deg)"
                                                },
                                                type: "button",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_arrow_left_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    fontSize: "small",
                                                    style: {
                                                        marginLeft: 17
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !!((ref2 = popularRoutes.content) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsText), "text-left mb-6 mt-8 lg:pl-4 px-4 lg:pr-0"),
                                children: "Popular routes"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsList), "lg:pl-8 px-4 lg:pr-0"),
                                children: popularRoutes.content.map(function(destination) {
                                    return getDirectionItem(destination);
                                })
                            }),
                            !!((ref3 = popularRoutes.content) === null || ref3 === void 0 ? void 0 : ref3.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsListPagination),
                                children: [
                                    !!+routesPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: getRoutesPaginationUrl(),
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsListPaginationItem), "font-fragment"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                style: {
                                                    zIndex: 2,
                                                    buttonOffset: 15,
                                                    borderRadius: "50%",
                                                    textAlign: "center",
                                                    border: "1.5px solid #D4A976",
                                                    backgroundColor: "#202020",
                                                    color: "#D4A976",
                                                    width: "50px",
                                                    height: "50px",
                                                    lineHeight: "50px",
                                                    marginRight: "1rem",
                                                    cursor: "pointer"
                                                },
                                                type: "button",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_arrow_left_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    fontSize: "small",
                                                    style: {
                                                        marginLeft: 17
                                                    }
                                                })
                                            }),
                                            "Previous"
                                        ]
                                    }),
                                    routesPage < totalRoutesPages - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: "/flights/".concat(cabinClass, "?directionsPage=").concat(+directionsPage, "&routesPage=").concat(+routesPage + 1),
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsListPaginationItem), "font-fragment ml-auto"),
                                        children: [
                                            "Next",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                style: {
                                                    zIndex: 2,
                                                    buttonOffset: 15,
                                                    borderRadius: "50%",
                                                    textAlign: "center",
                                                    border: "1.5px solid #D4A976",
                                                    backgroundColor: "#202020",
                                                    color: "#D4A976",
                                                    width: "50px",
                                                    height: "50px",
                                                    lineHeight: "50px",
                                                    marginLeft: "1rem",
                                                    cursor: "pointer",
                                                    transform: "rotate(180deg)"
                                                },
                                                type: "button",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_arrow_left_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    fontSize: "small",
                                                    style: {
                                                        marginLeft: 17
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !routesPage && !directionsPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_LandingPage_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popularDirectionsSeoHTML),
                        children: seoHTML
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container flex justify-center items-center sm:w-full lg:mt-10 2xl:mt-20",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RecommendationsList_RecommendationsList__WEBPACK_IMPORTED_MODULE_6__["default"], {
                            items: recommendation
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 39972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RecommendationsList": function() { return /* binding */ RecommendationsList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _RecommendationItem_RecommendationItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82039);
/* harmony import */ var _RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60815);
/* harmony import */ var _RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var RecommendationsList = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, _hideHeading = param.hideHeading, hideHeading = _hideHeading === void 0 ? false : _hideHeading, listView = param.listView, props = param.props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().listContainer)),
        children: [
            !hideHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().listTitle), "text-3xl font-fragment sm:mb-10 mb-20"),
                children: "More from First-Class.com"
            }),
            !listView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemBlock), items.length > 1 && "lg:grid lg:grid-cols-2 lg:gap-x-8"),
                children: !!items.length && items.map(function(item, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(items.length > 1 && i === items.length - 1 && (_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().halfWidth), (_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RecommendationItem_RecommendationItem__WEBPACK_IMPORTED_MODULE_2__/* .RecommendationItem */ .A, {
                            item: item
                        }, item.title)
                    }, item.title);
                })
            }),
            listView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemBlock), items.length > 1 && "flex flex-col items-center"),
                children: !!items.length && items.map(function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationsList_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RecommendationItem_RecommendationItem__WEBPACK_IMPORTED_MODULE_2__/* .RecommendationItem */ .A, {
                            item: item
                        }, item.title)
                    }, item.title);
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (RecommendationsList);


/***/ }),

/***/ 33562:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"landing":"LandingPage_landing__4Wkhn","introductionHeading":"LandingPage_introductionHeading___QneP","airlinesContainer":"LandingPage_airlinesContainer__hDq1D","airline":"LandingPage_airline__4SO6s","airlineLogo":"LandingPage_airlineLogo__L_7yc","topSectionSearch":"LandingPage_topSectionSearch__2XrwC","topDeals":"LandingPage_topDeals__xE5lk","contentSearch":"LandingPage_contentSearch__JwX41","topSection":"LandingPage_topSection__VEi96","topSectionText":"LandingPage_topSectionText__xV3_Y","introductionDescription":"LandingPage_introductionDescription__QEW2a","content":"LandingPage_content__KVj_T","contentBox":"LandingPage_contentBox__JT164","scrollableContent":"LandingPage_scrollableContent__LV1Uh","listTitle":"LandingPage_listTitle__oRb_S","darkContainer":"LandingPage_darkContainer__nLG_1","heading":"LandingPage_heading__93Oz2","popularDirectionsText":"LandingPage_popularDirectionsText__XtBSR","popularDirectionsSeoHTML":"LandingPage_popularDirectionsSeoHTML__vk_8i","popularDirectionsList":"LandingPage_popularDirectionsList__LhZq_","popularDirectionsListPagination":"LandingPage_popularDirectionsListPagination__RfiTG","popularDirectionsListPaginationItem":"LandingPage_popularDirectionsListPaginationItem___S80d","card":"LandingPage_card__CYbW_","recomendationContainer":"LandingPage_recomendationContainer__DZ5Bj","imageContainer":"LandingPage_imageContainer__PcWOI","text":"LandingPage_text__1FaZc","type":"LandingPage_type__U4_Yz","title":"LandingPage_title__Oae0H","icon":"LandingPage_icon__c4X3Y","readMore":"LandingPage_readMore__S_KhB","scrollableContentSub":"LandingPage_scrollableContentSub__WBGaS","seoContent":"LandingPage_seoContent__4OHrX","dealsTable":"LandingPage_dealsTable__IT8jf","dealsTableRegion":"LandingPage_dealsTableRegion__UJdPU"};

/***/ }),

/***/ 60815:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"RecommendationsList_listContainer__zOMv6","listTitle":"RecommendationsList_listTitle__pJJNc","halfWidth":"RecommendationsList_halfWidth__ejpzI"};

/***/ })

}]);